module.exports = __webpack_public_path__ + "static/img/3_3.7961ff8d.jpg";